export default {
    kasutajaTeenus: 'kasutajaTeenus',
}